/**
 * datalabels formatter
 * add total datalabel for stacked bar
 * add datalabel for pie chart only if have
 * @param value
 * @param ctx
 * @returns {string|*}
 */
Chart.defaults.global.plugins.datalabels.formatter = function (value, ctx) {
  if (value === null ||
    (value.hasOwnProperty('y') && value.y === null) ||
    (value.hasOwnProperty('x') && value.x === null)) {
    return null;
  }
  if (ctx.chart.options.total && ctx.chart.options.total.length > 0) {
    return displayTotalDatalabels(ctx);
  }
  if (ctx.chart.config.type === "pie") {
    return dataLabelPieFormatter(value, ctx);
  }
  var formattedValue = typeof value === "object" ? (value.hasOwnProperty('y') ? value.y : value.x) : value;
  return formattedValue.toLocaleString();
};

/**
 * format tooltip label
 * remove NaN value and add suffix if necessary
 * @param tooltipItem
 * @param data
 * @returns {string|null}
 */
Chart.defaults.global.tooltips.callbacks.label = function (tooltipItem, data) {
  var chart = this._chart;
  var tooltips = chart.options.tooltips;
  var total = data.total ? data.total : (chart.options.total ? chart.options.total : null);
  if (
    (isNaN(tooltipItem.yLabel) || (tooltips.zeroAsNull && tooltipItem.yLabel === 0)) &&
    (isNaN(tooltipItem.xLabel) || (tooltips.zeroAsNull && tooltipItem.xLabel === 0))
  ) {
    return null;
  }
  var datasets = data.datasets[tooltipItem.datasetIndex],
    value = datasets.data[tooltipItem.index].hasOwnProperty("formattedY") ?
      datasets.data[tooltipItem.index].formattedY : datasets.data[tooltipItem.index],
    label = datasets.label || '';

  var suffixLabel = datasets.suffixLabel && datasets.suffixLabel !== '' ? ' ' + datasets.suffixLabel : '';

  if (label !== '') {
    label += ': ';
  }
  label += value.toLocaleString();

  if (total != null) {
    label += ' (' + Math.round(value / total[tooltipItem.index] * 1000) / 10 + '%)';
  }

  return label + suffixLabel;
};

/**
 * add title on tooltip if in tooltips part, displayTitle is defined to true
 * @param tooltipItems
 * @param data
 * @returns {*|null}
 */
Chart.defaults.global.tooltips.callbacks.beforeTitle = function (tooltipItems, data) {
  return this._chart.options.tooltips.displayTitle ? this._chart.options.tooltips.displayTitle : null;
};

Chart.defaults.pie.tooltips.callbacks.title = function (tooltipItems, data) {
  return data.labels[tooltipItems[0].index];
};

Chart.defaults.pie.tooltips.callbacks.label = function (tooltipItem, data) {
  var chart = this._chart;
  var total = data.datasets[0]._meta[chart.controller.controller.id].total;
  var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  var percent = total ? (value * 100 / total).toFixed(1) : 0;
  return value + " (percent %)".replace("percent", percent);
};

Chart.defaults.global.legend.onClick = function (event, legendItem) {
  var datasetIndex = legendItem.datasetIndex;
  var chart = this.chart;
  var meta = chart.getDatasetMeta(datasetIndex);

  legendItem.hidden = !legendItem.hidden;
  meta.hidden = meta.hidden === null ? !chart.data.datasets[datasetIndex].hidden : null;

  if (chart.options.total && chart.options.total.length > 0) {
    if (!chart.data.hasOwnProperty("hiddenList")) {
      chart.data.hiddenList = [];
    }
    if (!chart.data.hasOwnProperty("total")) {
      chart.data.total = chart.options.total;
    }
    if (legendItem.hidden && !chart.data.hiddenList.includes(datasetIndex)) {
      chart.data.hiddenList.push(datasetIndex);
      chart.data.total = chart.data.total.map(function (total, dataIndex) {
        return total - chart.data.datasets[datasetIndex].data[dataIndex].value;
      });
    } else if (!legendItem.hidden && chart.data.hiddenList.includes(datasetIndex)) {
      chart.data.hiddenList.splice(chart.data.hiddenList.indexOf(datasetIndex))
      chart.data.total = chart.data.total.map(function (total, dataIndex) {
        return total + chart.data.datasets[datasetIndex].data[dataIndex].value;
      });
    }
    if (chart.options.percentMode) {
      chart.data.datasets.forEach(function (dataset, idx) {
        if (!chart.data.hiddenList.includes(idx)) {
          dataset.data.forEach(function (data, dataIdx) {
            var percent = data.value * 100 / chart.data.total[dataIdx];
            if (data.hasOwnProperty("y")) {
              data.y = percent;
            } else {
              data.x = percent;
            }
          });
        }
      });
    }
  }
  chart.update();
}

Chart.scaleService.updateScaleDefaults('linear', {
  ticks: {
    callback: function (value) {
      if (!isNaN(value) && Math.abs(this.end) > 5000 && value > 999) {
        return (value / 1000).toLocaleString() + 'k';
      }
      return value.toLocaleString();
    }
  },
  afterDataLimits: function (axis) {
    var suggestedMin = axis.min,
      suggestedMax = axis.max,
      setMinMax = Math.abs(suggestedMax - suggestedMin) > 10;
    if (suggestedMin !== null && suggestedMin < 0 && setMinMax) {
      suggestedMin -= Math.max(2, Math.round(0.05 * Math.abs(suggestedMin), 0));
    }
    if (suggestedMax !== null && suggestedMax > 0 && setMinMax) {
      suggestedMax += Math.max(2, Math.round(0.05 * Math.abs(suggestedMax), 0));
    }
    axis.min = suggestedMin;
    axis.max = suggestedMax;
  }
});

/**
 * display total value in top of stackedbar
 * @param ctx
 * @returns {string|*}
 */
function displayTotalDatalabels(ctx) {
  if (!ctx.chart.options.percentMode) {
    var datasets = ctx.chart.data.datasets.filter(function (ds, datasetIndex) {
      return ctx.chart.isDatasetVisible(datasetIndex);
    });
    if (datasets.indexOf(ctx.dataset) === datasets.length - 1 && ctx.chart.options.total[ctx.dataIndex] !== null) {
      if (ctx.chart.data.datasets.length === datasets.length) {
        return ctx.chart.options.total[ctx.dataIndex].toLocaleString();
      } else {
        return ctx.chart.data.total[ctx.dataIndex].toLocaleString();
      }
    }
  }
  return "";
}

/**
 * data label formatter for pie chart
 * @param value
 * @param ctx
 * @returns {string|string}
 */
function dataLabelPieFormatter(value, ctx) {
  var minVisible = 0.15;
  var minValueVisible = 0.08;
  var meta = ctx.dataset._meta[ctx.chart.controller.controller.id];
  var total = meta.total;
  var percent = total ? (value * 100 / total).toFixed(1) : 0;
  var ratioVisible = total ? value / total : 1;
  if (ratioVisible > minVisible) {
    return "value (percent %)"
      .replace("value", value.toLocaleString())
      .replace("percent", percent);
  }
  if (ratioVisible > minValueVisible) {
    return value.toLocaleString();
  }
  return "";
}


/**
 * plugin for display label in ces
 * for use add plugins:[cesLabel] on Chart
 * @type {{beforeDraw: cesLabel.beforeDraw}}
 */
var cesLabel = {
  beforeDraw: function (chart, easing) {
    var ctx = chart.chart.ctx;
    ctx.restore();
    var fontSize = (chart.height / 50).toFixed(2);
    ctx.font = fontSize + 'em "Helvetica Neue", Helvetica, Arial, sans-serif';
    ctx.textBaseline = "middle";
    var text = chart.config.data.datasets[0].data[0] + '%',
      textX = Math.round((chart.width - ctx.measureText(text).width) / 2),
      textY = chart.height / 2;
    ctx.fillText(text, textX, textY);
    ctx.save();
  }
};

var beforeDrawChart = {
  beforeDraw: function (chart, easing) {
    var ctx = chart.chart.ctx;
    ctx.save();
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, chart.width, chart.height);
    ctx.restore();
  }
};
